<template>
  <VSheet
    v-if="userStore.impersonator"
    class="px-4 d-flex align-center justify-center ga-2"
    color="warning"
    height="2.25rem"
    rounded
    data-testid="impersonationBadge"
  >
    <VIcon icon="co_present" />
    <span>{{ userStore.impersonator }}</span>
  </VSheet>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/userStore';

const userStore = useUserStore();
</script>
